import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress MetaMask connection errors (browser extension interference)
const originalError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('MetaMask')) {
    return; // Suppress MetaMask errors
  }
  originalError.apply(console, args);
};

// Handle uncaught errors related to MetaMask
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('MetaMask')) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
